import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiQueryHook } from '../../../../common/queryClient/createApiQueryHook';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import { AlgorithmSourcesFormDataSchema } from '../schema/AlgorithmSourcesFormDataSchema';
import { AlgorithmSourcesFormDataType } from '../schema/types';

interface AlgorithmSourcesQueryParams {
  id: number;
}

const getAlgorithmSources = (params?: AlgorithmSourcesQueryParams) =>
  apiClient
    .get<AlgorithmSourcesFormDataType>(expand(AlgorithmUrl.SOURCES, params))
    .then((response) => AlgorithmSourcesFormDataSchema.parse(response.data));

export const useGetAlgorithmSourcesQuery = createApiQueryHook(
  ['algorithm-sources'],
  getAlgorithmSources
);
